import { ReactNode, useMemo } from "react";
import { SideBarContainer } from "../../../../../../../../../components/SideBarContainer";
import { PayeeForm } from "../PayeeForm";
import { TRecord } from "../types";

type TOpenSidebar = {
  reloadData: () => void;
  payeesNumber: {
    primaryBuyerNumber: number;
    primarySellerNumber: number;
  };
  customSidebarClass: string;
  contractId: string;
  setRecord: React.Dispatch<React.SetStateAction<TRecord>>;
  record: TRecord;
  isPassthru: boolean;
  sidebarIsOpen: boolean;
  setSidebarIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useOpenSideBar = ({
  reloadData,
  payeesNumber,
  customSidebarClass,
  contractId,
  setRecord,
  record,
  isPassthru,
  sidebarIsOpen,
  setSidebarIsOpen
}: TOpenSidebar) => {
  const formWrapper: ReactNode = useMemo(() => {
    const formTitle = record.id !== null ? "Payee Details" : "Add Payee";

    return (
      <SideBarContainer title={formTitle} setShowSideBar={setSidebarIsOpen} customClass={customSidebarClass}>
        <PayeeForm
          reloadData={reloadData}
          payeesNumber={payeesNumber}
          setIsOpen={setSidebarIsOpen}
          contractId={contractId}
          record={record}
          setRecord={setRecord}
          isPassthru={isPassthru}
        />
      </SideBarContainer>
    );
  }, [record, setSidebarIsOpen, customSidebarClass, reloadData, payeesNumber, contractId, setRecord, isPassthru]);

  return { formWrapper, isOpen: sidebarIsOpen, setIsOpen: setSidebarIsOpen };
};
